module.exports = __webpack_public_path__ + "static/media/html5.063ce28a.svg";